import { TCreateTaskProps } from "./types/TCreateTaskProps";
import CreateModal from "./CreateModal";

const CreateTask = (props: TCreateTaskProps) => (
  <CreateModal boardRef={props.boardRef} />
);

export default CreateTask;
